export const dataSourceFailure = (state, action) => {
  return {
    error: action.payload,
  };
};

export const apiServiceErrorReducer = (state, action) => {
  const { error } = action.payload;
  return {
    error,
  };
};

export const isLoadingDataState = () => ({ isFetching: true });



// WEBPACK FOOTER //
// ./src/state/utils.js